import { render, staticRenderFns } from "./study.vue?vue&type=template&id=532f07ba&scoped=true&"
import script from "./study.vue?vue&type=script&lang=ts&"
export * from "./study.vue?vue&type=script&lang=ts&"
import style0 from "./study.vue?vue&type=style&index=0&id=532f07ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532f07ba",
  null
  
)

export default component.exports